export default __webpack_public_path__ + "static/Unionlive2-95987bea53c91a47f88e3424ae9ce361.png";